import React from 'react';
import { experience } from '../mock';
import { Briefcase, MapPin } from 'lucide-react';
import './Experience.css';

const Experience = () => {
  return (
    <section id="experience" className="experience-section">
      <div className="experience-container">
        <div className="experience-header">
          <span className="section-label">Experience</span>
          <h2 className="section-title">15 Years of Strategic Impact</h2>
          <p className="section-description">
            A proven track record of delivering results across government, policy, and private sectors
          </p>
        </div>

        <div className="timeline">
          {experience.map((exp, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <div className="timeline-header">
                  <span className="timeline-year">{exp.year}</span>
                  <div className="timeline-location">
                    <MapPin size={16} />
                    <span>{exp.location}</span>
                  </div>
                </div>
                <h3 className="timeline-title">{exp.title}</h3>
                <div className="timeline-organization">
                  <Briefcase size={18} />
                  <span>{exp.organization}</span>
                </div>
                <p className="timeline-description">{exp.description}</p>
                {exp.highlights && exp.highlights.length > 0 && (
                  <ul className="timeline-highlights">
                    {exp.highlights.map((highlight, idx) => (
                      <li key={idx}>{highlight}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
